import validate from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@25.6.0_@vue+compiler-sfc@3.5.33_cac@6.7.1_abb8b274e22302619c04cd6b77bd2d51/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/nuxtWeb/middleware/auth.global.ts";
import domain_45redirect_45global from "/nuxtWeb/middleware/domainRedirect.global.ts";
import manifest_45route_45rule from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@25.6.0_@vue+compiler-sfc@3.5.33_cac@6.7.1_abb8b274e22302619c04cd6b77bd2d51/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  domain_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/nuxtWeb/middleware/auth.ts")
}